import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
import { getViewSingleOrMultipleInvoicesCTA } from "./shared";
export var InvoiceBasicsIA = function InvoiceBasicsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BASICS_OF_INVOICES(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [INVOICES_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getViewSingleOrMulti;
        return (_getViewSingleOrMulti = getViewSingleOrMultipleInvoicesCTA(context, strictLocalize)) === null || _getViewSingleOrMulti === void 0 ? void 0 : _getViewSingleOrMulti.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getViewSingleOrMulti2, _getViewSingleOrMulti3;
        return (_getViewSingleOrMulti2 = getViewSingleOrMultipleInvoicesCTA(context, strictLocalize)) === null || _getViewSingleOrMulti2 === void 0 ? void 0 : (_getViewSingleOrMulti3 = _getViewSingleOrMulti2.getLink) === null || _getViewSingleOrMulti3 === void 0 ? void 0 : _getViewSingleOrMulti3.call(_getViewSingleOrMulti2, context.brandOrder);
      }
    }
  };
};
var BASICS_OF_INVOICES = function BASICS_OF_INVOICES(strictLocalize) {
  if (getSettingRetailerExclusivityAgreements()) {
    return strictLocalize({
      id: "3A9zhg",
      defaultMessage: [{
        "type": 0,
        "value": "About invoices"
      }]
    });
  }
  return strictLocalize({
    id: "Xj1+xD",
    defaultMessage: [{
      "type": 0,
      "value": "Basics of order invoices at Faire"
    }]
  });
};
var INVOICES_EXPLANATION = function INVOICES_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "RoogvG",
    defaultMessage: [{
      "type": 0,
      "value": "All retailers on Faire will receive an order invoice. Your invoice will be broken down into three main components, i.e. billing information, product information and payment information. Take a look at the Help Centre article for more details on each component. Click on the button to go to the invoice page. If you need more help, please contact us."
    }]
  });
};